
class Member {
  constructor(json = {}) {
    if (!json) json = {};

    this.id = "id" in json ? json.id : null;
    this.name = "name" in json ? json.name : null;
    this.isSpectator = "isSpectator" in json ? json.isSpectator : null;
    this.vote = "vote" in json ? json.vote : null;
  }
}

export default Member;
